

export const wrapNewsletterWithTemplate = (bodyContent) => {
  return `
  <div style="max-width: 700px; margin: auto; background: #fcfcfc; box-sizing: border-box; overflow-x: hidden;">
      <div class="header" style="text-align: center; margin-bottom: 20px; background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%); padding: 20px; color: #fcfcfc;">
        <img src="https://freecomers.com/logo1.png"
              alt="Freecomers Logo" style="max-width: 220px; height: auto;" />
         <p style=" font-size: 14px; font-weight: 300; margin: 0;">
            Global Space to Connect, Create, and Celebrate Cinema
          </p>
      </div>
                               

      <!-- Content -->
      <div class="content" style="overflow-x: auto; padding: 20px;">
        ${bodyContent}
      </div>

      <!-- Footer -->
     <div style="background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%); padding: 20px; color: #fcfcfc; text-align: center;">
  <p style="font-size: 14px; margin-bottom: 10px; font-weight: 500; color: #fcfcfc;">
    Crafted with passion by the Freecomers team
  </p>

  <!-- Links -->
  <div style="margin: 0; color: #fcfcfc;">
       <a href="https://www.facebook.com/people/Freecomers/61572890274779/" style="color: #fcfcfc; text-decoration: none; margin: 0 10px;">Facebook</a>
    <span style="opacity: 0.5;">|</span>

    <a href="https://www.instagram.com/freecomers/?igsh=NDFwMGNka2JtNTN5&utm_source=qr#" target="_blank"
       style="color: #fcfcfc; text-decoration: none; margin: 0 10px;">
       Instagram
    </a>
     <span style="opacity: 0.5;">|</span>

    <a href="https://www.linkedin.com/company/freecomers-filmworks/" target="_blank"
       style="color: #fcfcfc; text-decoration: none; margin: 0 10px;">
       LinkedIn
    </a>
    <span style="opacity: 0.5;">|</span>
    <a href="https://www.freecomers.com/" target="_blank"
        style="color: #fcfcfc; text-decoration: none; margin: 0 10px;">
         Website
    </a>
        <span style="opacity: 0.5;">|</span>
    <a href='{{unsubscribe_link}}' target="_blank"
        style="color: #fcfcfc; text-decoration: none; margin: 0 10px;">
         Unsubscribe
    </a>
  </div>
</div>


    </div>
  `;
};
